import React, {Component, PropTypes} from 'react';
import Cookies from 'cookies-js';

export default class Region extends Component {
  static propTypes = {
    region: PropTypes.object,
    fullView: PropTypes.bool,
    bgColor: PropTypes.string,
    textColor: PropTypes.string,
    collapsed: PropTypes.bool,
    cookieDomain: PropTypes.string
  };

  static defaultProps = {
    region: {},
    fullView: true,
    bgColor: "",
    textColor: "",
    collapsed: false,
    cookieDomain: ''
  };

  render() {
    let {
      bgColor,
      textColor,
      collapsed,
      cookieDomain = '',
      region: {
        text,
        link,
        image,
        itemContentHorizontal,
        forceRedirect,
        fullView,
      }}
     = this.props;

    let fontSize = 'medium';
    let localStyling = {
      'font-size': fontSize
    }, parentStyling = {};

    if (image) {
      image = <div className='region-image'><img src={image} /></div>;
      localStyling = {
        ...localStyling,
        'text-align': 'center',
        'margin': '5px'
      };
    }

    if (!fullView) {
      parentStyling = {
        'border-bottom': `1px solid ${textColor}`,
        'width': '100%',
        'background-color': `${bgColor}`
      };

      if (collapsed) {
        fontSize = 'small';
      }

      localStyling = {
        'margin': 0,
        'color': `${textColor}`,
        'font-size': fontSize
      };
    } else {
      parentStyling = {
        'text-align': 'center',
        'margin-top': '5px',
        'margin-bottom': '5px',
        'justify-content': 'space-evenly',
        'border': 'none',
        'min-width': '200px',
        'background-color': `${bgColor}`
      };

      if (!image) {
        parentStyling.width = '40%';
      }

      localStyling = {
        ...localStyling,
        'padding': '5px',
        'color': `${textColor}`
      };
    }

    let direction;
    if (itemContentHorizontal) {
      direction = 'row';
    } else {
      direction = 'column';
    }

    if (text) {
      text = (<div className='region-text' style={localStyling}>{text}</div>);
    }

    return (
      <div className='Region' style={{
        ...parentStyling,
        "flex-direction": direction,
      }}>
        <div style={{"width": "100%"}}>
          <a href={link} onClick={() => {
            if (process.env.BROWSER) {
              if (forceRedirect) {
                Cookies.set('regionLink', link, {
                  domain: `.${cookieDomain}`
                });
              }
            }
          }}>
            {image}
            {text}
          </a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/regionalization/Region.js